import { useEffect, useState, SyntheticEvent } from 'react'

// ** MUI Imports
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import Card from '@mui/material/Card'
import Tooltip from '@mui/material/Tooltip'
import CardHeader from '@mui/material/CardHeader'
import Typography from '@mui/material/Typography'
import axios from 'axios'
import {
    Autocomplete,
    CardActions,
    CardContent,
    Divider,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    Button,
    TextField
} from '@mui/material'
import Icon from '../../../components/icon';
import apiUrl from '../../../configs/constant';
import { useToast } from '../../../components/ToastProvider'
import { useNavigate } from 'react-router-dom'
import moment from 'moment'
import 'moment/locale/id'
import Swal from 'sweetalert2'

const Index = () => {
    const userData = JSON.parse(localStorage.getItem('user')!)
    const token = userData.token
    // ===== State =====
    const [listData, setListData] = useState<any[]>([])
    const [listCombo, setListCombo] = useState<any[]>([])
    const [listPeriodeAkhir, setListPeriodeAkhir] = useState<any[]>([])
    const [valPeriodeAkhir, setValPeriodeAkhir] = useState<any>(null)

    const [listPeriodeAwal, setListPeriodeAwal] = useState<any[]>([])
    const [valPeriodeAwal, setValPeriodeAwal] = useState<any>(null)

    const [cardStates, setCardStates] = useState<Record<number, { loading: boolean; arrItems: any[] }>>({})

    useEffect(() => {
        getListPeriode()
        getListCombo()
    }, [])

    useEffect(() => {
        if (!listData || listData.length === 0) {
            setCardStates({})
            return
        }

        const init: Record<number, { loading: boolean; arrItems: any[] }> = {}
        listData.forEach(d => {
            init[d.id] = {
                loading: false,
                arrItems: listCombo.map(s => ({ ...s }))
            }
        })
        setCardStates(init)

    }, [listData])

    const getDataFilter = (tglAwal: any, tglAkhir: any) => {
        Swal.fire({
            title: 'Now loading',
            allowEscapeKey: false,
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading()
            }
        })

        const url = apiUrl.apiUrl + '/acc/laporan-keuangan/master-rekalkulasi-persediaan'
        axios
            .get(url, {
                params: { tgl_awal: tglAwal, tgl_akhir: tglAkhir },
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    setListData(data)
                    Swal.close()
                } else {
                    Swal.fire({
                        title: 'Pemberitahuan',
                        text: response.data.message,
                        icon: 'error'
                    })
                }
            })
            .catch(err => {
                Swal.close()
                Swal.fire({ title: 'Error', text: err.message || 'Terjadi kesalahan', icon: 'error' })
            })
    }

    const getListPeriode = () => {
        const url = apiUrl.apiUrl + '/acc/laporan-keuangan/list-periode'
        axios
            .get(url, {
                params: {},
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    setListPeriodeAwal(data)
                    setListPeriodeAkhir(data)
                    if (data && data.length > 0) {
                        setValPeriodeAwal(data[0])
                        setValPeriodeAkhir(data[0])
                        getDataFilter(data[0].id, data[0].id)
                    }
                } else {
                    Swal.fire({
                        title: 'Pemberitahuan',
                        text: response.data.message,
                        icon: 'error'
                    })
                }
            })
            .catch(err => {
                Swal.fire({ title: 'Error', text: err.message || 'Terjadi kesalahan', icon: 'error' })
            })
    }

    const getListCombo = () => {
        const url = apiUrl.apiUrl + '/acc/laporan-keuangan/list-combo-rekalkulasi'
        axios
            .get(url, {
                params: {},
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    setListCombo(response.data.data)
                } else {
                    Swal.fire({
                        title: 'Pemberitahuan',
                        text: response.data.message,
                        icon: 'error'
                    })
                }
            })
            .catch(err => {
                Swal.fire({ title: 'Error', text: err.message || 'Terjadi kesalahan', icon: 'error' })
            })
    }

    const handleChangeAutocompleteAwal = (event: SyntheticEvent, newValue: any | null) => {
        if (newValue != null) {
            setValPeriodeAwal(newValue)
        } else {
            setValPeriodeAwal(null)
        }
    }

    const handleChangeAutocompleteAkhir = (event: SyntheticEvent, newValue: any | null) => {
        if (newValue != null) {
            setValPeriodeAkhir(newValue)
        } else {
            setValPeriodeAkhir(null)
        }
    }

    const handlePosting = async (periodeId: number) => {
        if (!cardStates[periodeId]) return

        setCardStates(prev => ({
            ...prev,
            [periodeId]: {
                ...prev[periodeId],
                loading: true,
                arrItems: prev[periodeId].arrItems.map(a => ({ ...a, status: null, message: '' }))
            }
        }))

        for (let i = 0; i < listCombo.length; i++) {
            try {
                const url = `${apiUrl.apiUrl}/acc/laporan-keuangan/detail-rekalkulasi-persediaan`
                const res = await axios.post(
                    url,
                    {
                        step: i + 1,
                        id_periode: periodeId
                    },
                    {
                        headers: { Authorization: `Bearer ${token}` }
                    }
                )

                const isSuccess = !!res.data.success

                setCardStates(prev => {
                    const card = prev[periodeId]
                    if (!card) return prev
                    const nextItems = [...card.arrItems]
                    nextItems[i] = {
                        ...nextItems[i],
                        status: isSuccess,
                        message: res.data.message || ''
                    }
                    return {
                        ...prev,
                        [periodeId]: { ...card, arrItems: nextItems }
                    }
                })

                if (!isSuccess) break
            } catch (err: any) {
                setCardStates(prev => {
                    const card = prev[periodeId]
                    if (!card) return prev
                    const nextItems = [...card.arrItems]
                    nextItems[i] = {
                        ...nextItems[i],
                        status: false,
                        message: err?.response?.data?.message || err.message || 'Error saat koneksi'
                    }
                    return {
                        ...prev,
                        [periodeId]: { ...card, arrItems: nextItems }
                    }
                })
                break
            }

            await new Promise(r => setTimeout(r, 200))
        }

        // Matikan loading setelah semua step selesai
        setCardStates(prev => ({
            ...prev,
            [periodeId]: { ...prev[periodeId], loading: false }
        }))
    }


    return (
        <Grid container spacing={3} sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
            <Grid item xs={12}>
                <div className={'content-block dx-card'}>
                    <Box
                        sx={{
                            width: '100%',
                            display: 'flex',
                            flexWrap: 'wrap',
                            alignItems: 'center',
                            justifyContent: 'space-between'
                        }}
                    >
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>
                            <CardHeader title='REKALKULASI PERSEDIAAN' />
                        </Box>
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}></Box>
                    </Box>
                    <Divider />
                    <CardContent>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={3}>
                                <Autocomplete
                                    value={valPeriodeAwal}
                                    options={listPeriodeAwal}
                                    id="Periode Awal"
                                    isOptionEqualToValue={(option, value) => option.id === value.id}
                                    onChange={handleChangeAutocompleteAwal}
                                    renderOption={(props, option) => {
                                        return (
                                            <li {...props} key={option.id}>
                                                {option.periode}
                                            </li>
                                        )
                                    }}
                                    getOptionLabel={option => option.periode}
                                    renderInput={params => <TextField {...params} label="Periode Awal" />}
                                />
                            </Grid>

                            <Grid item xs={12} sm={3}>
                                <Autocomplete
                                    value={valPeriodeAkhir}
                                    options={listPeriodeAkhir}
                                    id="Periode Akhir"
                                    isOptionEqualToValue={(option, value) => option.id === value.id}
                                    onChange={handleChangeAutocompleteAkhir}
                                    renderOption={(props, option) => {
                                        return (
                                            <li {...props} key={option.id}>
                                                {option.periode}
                                            </li>
                                        )
                                    }}
                                    getOptionLabel={option => option.periode}
                                    renderInput={params => <TextField {...params} label="Periode Akhir" />}
                                />
                            </Grid>

                            <Grid item xs={12} sm={3}>
                                <Button
                                    sx={{ marginTop: 2, marginLeft: 3, marginRight: 3 }}
                                    variant="contained"
                                    color="primary"
                                    startIcon={<Icon icon="mdi:magnify" />}
                                    onClick={() => getDataFilter(valPeriodeAwal?.id, valPeriodeAkhir?.id)}
                                >
                                    Cari Data
                                </Button>
                            </Grid>
                        </Grid>

                        <Grid container spacing={4} sx={{ my: 6 }}>
                            {listData.map((item, index) => {
                                const card = cardStates[item.id] || { loading: false, arrItems: listCombo.map(s => ({ ...s })) }
                                return (
                                    <Grid item xs={12} sm={4} key={index}>
                                        <Card sx={{ width: 400 }} variant="outlined">
                                            <CardContent>
                                                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5, mb: 2 }}>
                                                    <Box sx={{ display: 'flex' }}>
                                                        <Typography sx={{ width: 130, fontWeight: 500 }} variant="body1">
                                                            Periode
                                                        </Typography>
                                                        <Typography variant="body1">: {item.keterangan}</Typography>
                                                    </Box>
                                                    <Box sx={{ display: 'flex' }}>
                                                        <Typography sx={{ width: 130, fontWeight: 500 }} variant="body1">
                                                            Tanggal Awal
                                                        </Typography>
                                                        <Typography variant="body1">: {moment(item.tgl_awal).format('LL')}</Typography>
                                                    </Box>
                                                    <Box sx={{ display: 'flex' }}>
                                                        <Typography sx={{ width: 130, fontWeight: 500 }} variant="body1">
                                                            Tanggal Akhir
                                                        </Typography>
                                                        <Typography variant="body1">: {moment(item.tgl_akhir).format('LL')}</Typography>
                                                    </Box>
                                                </Box>

                                                <Divider sx={{ mb: 2 }} />

                                                <List dense disablePadding>
                                                    {card.arrItems.map((step, idx) => (
                                                        <ListItem
                                                            key={idx}
                                                            sx={{
                                                                py: 0.5,
                                                                px: 0,
                                                                borderBottom: idx < card.arrItems.length - 1 ? '1px solid #eee' : 'none'
                                                            }}
                                                            secondaryAction={
                                                                <ListItemIcon sx={{ minWidth: 32 }}>
                                                                    {step.status === true ? (
                                                                        <Icon icon="mdi:check-circle" color="green" fontSize={22} />
                                                                    ) : step.status === false ? (
                                                                        <Tooltip title={step.message || ''}>
                                                                            <Icon icon="mdi:close-circle" color="red" fontSize={22} />
                                                                        </Tooltip>
                                                                    ) : (
                                                                        <Icon icon="mdi:clock-outline" color="#999" fontSize={22} />
                                                                    )}
                                                                </ListItemIcon>
                                                            }
                                                        >
                                                            <ListItemText primary={step.label} />
                                                        </ListItem>
                                                    ))}
                                                </List>
                                            </CardContent>

                                            <CardActions sx={{ justifyContent: 'center' }}>
                                                <Button
                                                    variant="contained"
                                                    size="small"
                                                    color="primary"
                                                    disabled={card.loading}
                                                    onClick={() => handlePosting(item.id)}
                                                    startIcon={<Icon icon={card.loading ? 'mdi:loading' : 'mdi:send'} className={card.loading ? 'spin' : ''} />}
                                                >
                                                    {card.loading ? 'PROSES...' : 'MULAI'}
                                                </Button>
                                            </CardActions>
                                        </Card>
                                    </Grid>
                                )
                            })}
                        </Grid>
                    </CardContent>
                </div>
            </Grid>
        </Grid>
    )
}

export default Index